var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.navbar_show)?_c('navbar'):_vm._e(),_c('router-view',{on:{"navbar":_vm.navbar,"footer":_vm.footer}}),(_vm.footer_show)?_c('footer-bar'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }